import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Register.css";

const RegisterButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      className="register-button btn btn-outline-light"
      onClick={() => navigate("/register")}
    >
      {t("navbar.register")}
    </button>
  );
};

export default RegisterButton;
